<template>
  <v-layout row wrap v-if="repeatService != null" mt-2 mr-2 pr-2 style="width: 100%;">
    <v-flex v-if="mode == 'editDayTrip'" md12 lg5 pl-2>
      <SimpleCard>
        <v-layout column>
          <h5>Apply Changes to every {{ dayForAddDayTrip }}</h5>
          <v-layout pt-1 row wrap align-content-center justify-center>
            <v-layout row wrap>
              <v-flex>
                <TripForm
                  keyName="amend"
                  :repeatTripDefinition="definitionForAddDayTrip"
                  :repeatBookingForm="templateForAddDayTrip"
                  :repeatService="repeatService"
                  :updateMode="false"
                  :alterMode="true"
                  @cancel="mode = null"
                  @alter="submitEditDayTrip"
                  :loading="repeatService.loading"
                ></TripForm>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-layout>
      </SimpleCard>
    </v-flex>
    <v-flex v-if="mode == 'addDayTrip'" md12 lg5 pl-2>
      <SimpleCard>
        <v-layout column>
          <h5>Apply Changes to every {{ dayForAddDayTrip }}</h5>
          <v-layout pt-1 row wrap align-content-center justify-center>
            <v-layout row wrap>
              <v-flex>
                <TripForm
                  keyName="amend"
                  :repeatTripDefinition="definitionForAddDayTrip"
                  :repeatBookingForm="templateForAddDayTrip"
                  :repeatService="repeatService"
                  :updateMode="false"
                  :alterMode="true"
                  @cancel="mode = null"
                  @alter="submitAddDayTrip"
                  :loading="repeatService.loading"
                ></TripForm>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-layout>
      </SimpleCard>
    </v-flex>
     <v-flex v-if="mode == 'alter'" md12 lg5 pl-2>
      <SimpleCard>
        <v-layout column>
          <h5>Alter Trip</h5>
          <v-layout pt-1 row wrap align-content-center justify-center>
            <v-layout row wrap>
              <v-flex xs6 pb-2>
                <v-radio-group hide-details row label="Apply to trips:" v-model="amendType">
                  <v-radio label="Date Span" :value="0"></v-radio>
                  <v-radio label="Selected Trips" :value="1"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12>
                <TripDurationForm
                  v-if="amendType == 0"
                  :repeatTripDefinition="amendTripDefinition"
                  :error="dateSpanErrors"
                  :repeatBookingForm="amendTripDefinition.repeat_trip_template"
                  label="Make changes between these dates"
                />
              </v-flex>
              <v-flex xs12>
                <v-radio-group
                  @change="amendTargetChanged"
                  row
                  label="Apply to:"
                  v-model="amendTarget"
                >
                  <v-radio label="Outbound" :value="0"></v-radio>
                  <v-radio label="Return" :value="1"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex>
                <TripForm
                  keyName="amend"
                  :repeatTripDefinition="amendTripDefinition"
                  :repeatBookingForm="amendTripDefinition.repeat_trip_template"
                  :repeatService="repeatService"
                  :updateMode="false"
                  :alterMode="true"
                  @cancel="mode = null"
                  @alter="submitTripAlteration"
                  :loading="repeatService.loading"
                ></TripForm>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-layout>
      </SimpleCard>
    </v-flex>
    <v-flex xs6 md4 lg2 pl-2 v-if="mode == 'alter'">
      <v-layout row wrap>
        <v-flex xs12>
          <SimpleCard>
            <DaysOfWeekTimes
              :repeatTripDefinition="amendTripDefinition"
              :errorOutbound="dayOfWeekErrors"
              :errorReturn="dayOfWeekErrors"
            />
          </SimpleCard>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-if="mode == 'alter'" style="height: 100%;" md12 lg5 pl-2>
      <SimpleCard>
        <v-layout column>
          <h5>Trip Changes</h5>
          <v-layout pt-1 row wrap align-content-center justify-center>
            <v-layout row wrap>
              <TripChanges
                :oldTripDefinition="amendTarget == 0 ? repeatService.repeatServiceModel.trip_a : repeatService.repeatServiceModel.trip_b"
                :newTripDefinition="amendTripDefinition"
              />
            </v-layout>
          </v-layout>
        </v-layout>
      </SimpleCard>
    </v-flex>
    <v-flex v-if="mode == null" md12 lg5 pl-2 pr-2 pt-1>
      <SimpleCard>
        <v-col>
          <TripDurationForm
            title="Outbound Trip"
            :repeatTripDefinition="repeatService.repeatServiceModel.trip_a"
            :error="outboundDatespanErrors"
            :repeatBookingForm="repeatService.repeatServiceModel.trip_a.repeat_trip_template"
          />
          <v-flex pb-2><DayTripModifiers
           @edit="function(rtt) { beginEditDayTripTemplate( repeatService.repeatServiceModel.trip_a, true, rtt) }"
           @remove="function(rtt) { removeDayTrip( repeatService.repeatServiceModel.trip_a, rtt, true) }" @addDayTrip="addDayTripTemplate(repeatService.repeatServiceModel.trip_a, true)" :dayTripModifiers="repeatService.repeatServiceModel.trip_a.repeat_trip_template_dows" /></v-flex>
          <TripForm
            keyName="outbound"
            :repeatTripDefinition="repeatService.repeatServiceModel.trip_a"
            :repeatBookingForm="repeatService.repeatServiceModel.trip_a.repeat_trip_template"
            :repeatService="repeatService"
            :updateMode="repeatService.repeatServiceModel.trip_a.id != null"
            @create="createRepeatTripOutbound"
            @update="updateRepeatTripOutbound"
            @addReturnTrip="addReturnTrip"
            :loading="repeatService.loadingA"
          />
        </v-col>
      </SimpleCard>
    </v-flex>
    <v-flex
      md12
      lg5
      pl-2
      pr-2
      pt-1
      v-if="repeatService.repeatServiceModel.trip_b != null && mode == null"
    >
      <SimpleCard>
        <v-col>
          <TripDurationForm
            title="Return Trip"
            :repeatTripDefinition="repeatService.repeatServiceModel.trip_b"
            :error="returnDatespanErrors"
            :repeatBookingForm="repeatService.repeatServiceModel.trip_b.repeat_trip_template"
          />
          <v-flex pb-2><DayTripModifiers 
           @edit="function(rtt) { beginEditDayTripTemplate( repeatService.repeatServiceModel.trip_b, false, rtt) }"
           @remove="function(rtt) { removeDayTrip( repeatService.repeatServiceModel.trip_b, rtt, false) }"  @addDayTrip="addDayTripTemplate(repeatService.repeatServiceModel.trip_b, false)" :dayTripModifiers="repeatService.repeatServiceModel.trip_b.repeat_trip_template_dows" /></v-flex>
          <TripForm
            keyName="return"
            :repeatTripDefinition="repeatService.repeatServiceModel.trip_b"
            :repeatBookingForm="repeatService.repeatServiceModel.trip_b.repeat_trip_template"
            :repeatService="repeatService"
            @update="updateRepeatTripReturn"
            :updateMode="repeatService.repeatServiceModel.trip_b.id != null"
            @create="createRepeatTripReturn"
            :loading="repeatService.loadingB"
          />
        </v-col>
      </SimpleCard>
    </v-flex>
    <v-flex xs6 md4 lg2 pl-2 v-if="mode == null">
      <v-row>
        <v-flex xs12>
          <SimpleCard>
            <DaysOfWeekTimes
              :repeatService="repeatService"
              :errorOutbound="outboundDayOfWeekErrors"
              :errorReturn="returnDayOfWeekErrors"
            />
          </SimpleCard>
        </v-flex>
        <v-flex xs12 mt-2>
          <SimpleCard>
            <BulkActionOptions @loadBookings="loadBookings" :repeatService="repeatService" @alter="alter" />
          </SimpleCard>
        </v-flex>
      </v-row>
    </v-flex>
    <v-flex v-if="loadedTrips == true" xs12 mt-3 pl-2>
      <SimpleCard>
        <RepeatTripList
          :repeatService="repeatService"
          :loading="repeatService.loadingA || repeatService.loadingB || repeatService.loading"
          :mode="mode"
          :amendTarget="amendTarget"
          :amendType="amendType"
        />
      </SimpleCard>
      <v-flex v-if="!loading" pt-2 md12 class="text-center pt-2 justify-center">
        <v-pagination
            @input="changePage"
            v-model="pagination.page"
            :length="num_pages"
        ></v-pagination>
      </v-flex>
    </v-flex>
    <v-flex v-if="loadingTrips == true" xs12 mt-3 pl-2>
      <v-layout align-center justify-center>
        <v-progress-circular
          indeterminate
          color="primary"
          :size="70"
        ></v-progress-circular>
      </v-layout>
    </v-flex>
    <v-dialog persistent v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="white--text grey">
          <h3 class="nobold">{{ mode == 'alter' ? 'Confirm Alter' : 'Confirm Update' }}</h3>
        </v-card-title>
        <v-card-text>
          <v-flex px-2>
            <v-textarea label="Notes" v-model="notes" />
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="blue" class="text-none" @click="activeSubmitUpdateCallback">Confirm</v-btn>
          <v-btn
            flat
            color="red"
            class="text-none"
            @click="function() { dialog = false; notes = ''}"
          >Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog >
      <v-dialog v-if="addDayTripTemplateDialog" persistent v-model="addDayTripTemplateDialog" max-width="500">
      <v-card>
        <v-card-actions>
          <v-select item-name="text" item-value="value" v-model="dayForAddDayTrip" :items="dayArray(definitionForAddDayTrip)" />
          <v-spacer></v-spacer>
          <v-btn
            text
            class="text-none" 
            @click="function() { addDayTripTemplateDialog = false;}"
          >Cancel</v-btn>
          <v-btn text class="text-none" @click="beginAddDayTripTemplate()">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import TripChanges from "@/components/repeat_service/TripChanges.vue";
import TripDurationForm from "@/components/repeat_service/TripDurationForm.vue";
import BulkActionOptions from "@/components/repeat_service/BulkActionOptions.vue";
import TripForm from "@/components/repeat_service/TripForm.vue";
import DaysOfWeekTimes from "@/components/repeat_service/DaysOfWeekTimes.vue";

import DayTripModifiers from "@/components/repeat_service/DayTripModifiers.vue";
import RepeatTripList from "@/components/repeat_service/RepeatTripList.vue";

import { RepeatService } from "@/components/util/RepeatService.js";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import moment from "moment";

import { BookingForm } from "@/components/util/BookingForm.js";

export default {
  name: "edit_repeat_service",
  components: {
    SimpleCard,
    TripForm,
    TripDurationForm,
    BulkActionOptions,
    DaysOfWeekTimes,
    RepeatTripList,
    DayTripModifiers,
    TripChanges,
  },
  data: function () {
    return {
      addDayTripTemplateDialog: false,
      definitionForAddDayTrip: null,
      templateForAddDayTrip: null,
      dayForAddDayTrip: null,
      loadedTrips: false,
      loadingTrips: false,
      repeatService: null,
      rideTypes: [],
      loading: true,
      dateSpanErrors: null,
      dayOfWeekErrors: null,
      outboundDatespanErrors: null,
      outboundDayOfWeekErrors: null,
      returnDatespanErrors: null,
      returnDayOfWeekErrors: null,
      mode: null,
      amendTarget: 0,
      amendType: 0,
      amendTripDefinition: null,
      dialog: false,
      notes: "",
      activeSubmitUpdateCallback: null,
      pagination: { page: 1 },
      num_pages: 0,
      count: 10,
    };
  },
  computed: {
    hasReturnTrip: function () {
      console.log(this.repeatService.hasReturnTrip());
      return this.repeatService.hasReturnTrip();
    },
  },
  mounted: async function () {
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      `https://maps.googleapis.com/maps/api/js?key=AIzaSyAFmKKMOPyZtr6zwvFQswoeUHU0T590xdI&libraries=places,geometry`
    );

    document.head.appendChild(recaptchaScript);

    console.log("Mounted");

    this.getRideTypes();
  },
  methods: {
    removeDayTrip: function(definition,rtt, outbound) {

      for( var i = 0; i < definition.repeat_trip_template_dows.length; i++){ 
      
          if ( definition.repeat_trip_template_dows[i] == rtt) { 
            console.log("Removed " + rtt.day_of_week + " from list");
            definition.repeat_trip_template_dows.splice(i, 1); 
          }
      
      }

      var vm = this;

      this.repeatService.alterRepeatTripDOW(
        outbound,
        definition,
        0,
        "", function() {
          vm.mode = null;
          vm.loadedTrips = true;
        }
      );

    },
    submitEditDayTrip: function() {

      var vm = this;

      this.repeatService.alterRepeatTripDOW(
        this.amendTarget == 0,
        this.definitionForAddDayTrip,
        0,
        "", function() {
          vm.mode = null;
          vm.loadedTrips = true;
        }
      );

    },
    submitAddDayTrip: function() {

      this.definitionForAddDayTrip.repeat_trip_template_dows.push({ "repeat_trip_template": this.templateForAddDayTrip, "day_of_week": this.dayForAddDayTrip});
      
      var vm = this;

      this.repeatService.alterRepeatTripDOW(
        this.amendTarget == 0,
        this.definitionForAddDayTrip,
        0,
        "", function() {
          vm.loadedTrips = true;
          vm.mode = null;
        }
      );

    },
    beginEditDayTripTemplate: function(definitionForAddDayTrip, outbound, rtt) {

        this.dayForAddDayTrip = rtt.day_of_week;

        this.amendTarget = outbound ? 0 : 1
        this.definitionForAddDayTrip = definitionForAddDayTrip;
        this.templateForAddDayTrip = rtt.repeat_trip_template;

        this.mode = "editDayTrip";
      
    },
    beginAddDayTripTemplate: function() {
      if (this.dayForAddDayTrip != null) {

        const getCircularReplacer = () => {
          const seen = new WeakSet();
          return (key, value) => {
            if (typeof value === "object" && value !== null) {
              if (seen.has(value)) {
                return;
              }
              seen.add(value);
            }
            return value;
          };
        }; 

        var bookingUser = {
          booking: JSON.parse(
            JSON.stringify(this.definitionForAddDayTrip.repeat_trip_template.booking)
          ),
          user: this.definitionForAddDayTrip.repeat_trip_template.user,
        };

        this.templateForAddDayTrip = new BookingForm(
          this.rideTypes,
          bookingUser,
          this.$store
        );

  
        this.mode = "addDayTrip";

        this.addDayTripTemplateDialog = false;
      }
    },
    dayArray: function () {

      var items = [
        {
          "text": "Monday",
          "value": "mon",
        },
        {
          "text": "Tuesday",
          "value": "tue",
        },{
          "text": "Wednesday",
          "value": "wed",
        },{
          "text": "Thursday",
          "value": "thu",
        },{
          "text": "Friday",
          "value": "fri",
        },{
          "text": "Saturday",
          "value": "sat",
        },{
          "text": "Sunday",
          "value": "sun",
        }
      ]

      for (var i = 0; i < this.definitionForAddDayTrip.repeat_trip_template_dows.length; i++) {
        let dowRTT = this.definitionForAddDayTrip.repeat_trip_template_dows[i];

        for (var j = 0; j < items.length; j++) {

          if (items[j].value == dowRTT.day_of_week) {
            items.splice(j, 1);
          }

        }
      }

      return items;
      

    },
    addDayTripTemplate: function(definitionForAddDayTrip, outbound) {

      this.dayForAddDayTrip = null;

      this.amendTarget = outbound ? 0 : 1

      this.definitionForAddDayTrip = definitionForAddDayTrip;
      this.addDayTripTemplateDialog = true
    },
    amendTargetChanged: function () {
      console.log("Amend Target " + this.amendTarget);

      var tripDefinition = null;
      if (this.amendTarget == 0) {
        tripDefinition = this.repeatService.repeatServiceModel.trip_a;
      } else {
        tripDefinition = this.repeatService.repeatServiceModel.trip_b;
      }

      var amendTripDefinition = {};

      var bookingUser = {
        booking: JSON.parse(
          JSON.stringify(tripDefinition.repeat_trip_template.booking)
        ),
        user: tripDefinition.repeat_trip_template.user,
      };

      amendTripDefinition.repeat_trip_template = new BookingForm(
        this.rideTypes,
        bookingUser,
        this.$store
      );

      console.log("leh");

      amendTripDefinition.repeat_trip_template.getCustomer(
        this.repeatService.repeatServiceModel.user.contact_number
      );

      amendTripDefinition.day_of_week_times_list = JSON.parse(
        JSON.stringify(
          RepeatService.populatePartialDayOfWeekArray(
            tripDefinition.day_of_week_times_list
          )
        )
      );

      amendTripDefinition.date_span = JSON.parse(
        JSON.stringify(tripDefinition.date_span)
      );

      this.amendTripDefinition = amendTripDefinition;

      this.loadBookings();
    },
    alter: function () {
      this.amendTargetChanged();
      this.mode = "alter";
    },
    addReturnTrip: function () {
      this.repeatService.addCreateReturnTrip();
      this.$forceUpdate();

      console.log("Add create return trip");

      console.log(this.repeatService.repeatServiceModel.trip_b);
      console.log(this.repeatService.hasReturnTrip());
    },
    createRepeatTripOutbound: function () {
      console.log("Create repeat trip outbound");
      // we have validated a booking

      // now validate datespan, and the

      var dateSpan = this.repeatService.repeatServiceModel.trip_a.date_span;
      var daysOfWeeks = this.repeatService.repeatServiceModel.trip_a
        .day_of_week_times_list;

      this.outboundDatespanErrors = this.validateDateSpan(dateSpan);
      this.outboundDayOfWeekErrors = this.validateDayOfWeeks(daysOfWeeks);

      if (
        this.outboundDatespanErrors != null ||
        this.outboundDayOfWeekErrors != null
      ) {
        console.log(this.outboundDatespanErrors);
        console.log(this.outboundDayOfWeekErrors);
        return;
      }

      this.repeatService.addRepeatTrip(true);
    },
    createRepeatTripReturn: function () {
      console.log("Create repeat trip return");
      // we have validated a booking

      // now validate datespan, and the

      var dateSpan = this.repeatService.repeatServiceModel.trip_b.date_span;
      var daysOfWeeks = this.repeatService.repeatServiceModel.trip_b
        .day_of_week_times_list;

      this.returnDatespanErrors = this.validateDateSpan(dateSpan);
      this.returnDayOfWeekErrors = this.validateDayOfWeeks(daysOfWeeks);

      if (
        this.returnDatespanErrors != null ||
        this.returnDayOfWeekErrors != null
      ) {
        console.log(this.returnDatespanErrors);
        console.log(this.returnDayOfWeekErrors);
        return;
      }

      this.repeatService.addRepeatTrip(false);
    },
    submitTripAlteration: function () {
      console.log("Validating trip alteration");

      var dateSpan = this.amendTripDefinition.date_span;
      var daysOfWeeks = this.amendTripDefinition.day_of_week_times_list;

      this.dateSpanErrors = this.validateDateSpan(dateSpan);
      this.dayOfWeekErrors = this.validateDayOfWeeks(daysOfWeeks);

      if (this.dateSpanErrors != null || this.dayOfWeekErrors != null) {
        console.log(this.dateSpanErrors);
        console.log(this.dayOfWeekErrors);
        return;
      }

      console.log("Submitting trip alteration");

      this.dialog = true;

      var vm = this;

      this.activeSubmitUpdateCallback = function () {
        vm.dialog = false;

        vm.repeatService.alterRepeatTrip(
          vm.amendTarget == 0,
          vm.amendTripDefinition,
          vm.amendType,
          vm.notes,
          false
        );
      };
    },
    updateRepeatTripOutbound: function () {
      console.log("Create repeat trip outbound");
      // we have validated a booking

      // now validate datespan, and the

      var dateSpan = this.repeatService.repeatServiceModel.trip_a.date_span;
      var daysOfWeeks = this.repeatService.repeatServiceModel.trip_a
        .day_of_week_times_list;

      this.outboundDatespanErrors = this.validateDateSpan(dateSpan);
      this.outboundDayOfWeekErrors = this.validateDayOfWeeks(daysOfWeeks);

      if (
        this.outboundDatespanErrors != null ||
        this.outboundDayOfWeekErrors != null
      ) {
        console.log(this.outboundDatespanErrors);
        console.log(this.outboundDayOfWeekErrors);
        return;
      }

      this.dialog = true;

      var vm = this;

      this.activeSubmitUpdateCallback = function () {
        vm.dialog = false;
        vm.repeatService.updateRepeatTrip(true, vm.notes);
      };
    },
    updateRepeatTripReturn: function () {
      console.log("Create repeat trip return");
      // we have validated a booking

      // now validate datespan, and the

      var dateSpan = this.repeatService.repeatServiceModel.trip_b.date_span;
      var daysOfWeeks = this.repeatService.repeatServiceModel.trip_b
        .day_of_week_times_list;

      this.returnDatespanErrors = this.validateDateSpan(dateSpan);
      this.returnDayOfWeekErrors = this.validateDayOfWeeks(daysOfWeeks);

      if (
        this.returnDatespanErrors != null ||
        this.returnDayOfWeekErrors != null
      ) {
        console.log(this.returnDatespanErrors);
        console.log(this.returnDayOfWeekErrors);
        return;
      }

      this.dialog = true;

      var vm = this;

      this.activeSubmitUpdateCallback = function () {
        vm.dialog = false;
        vm.repeatService.updateRepeatTrip(false, vm.notes);
      };
    },
    validateDateSpan: function (date_span) {
      try {
        var start = moment(date_span.start_date, "YYYY-MM-DD");
        var end = moment(date_span.end_date, "YYYY-MM-DD");

        if (start.isAfter(end)) {
          return "End date must be after start date";
        }
      } catch (e) {
        console.log(e);
        return "Error in date span - Please ensure dates were selected through calender / are in correct format";
      }
    },
    validateDayOfWeeks: function (day_of_weeks) {
      var empty = true;

      for (var i = 0; i < day_of_weeks.length; i++) {
        var dow = day_of_weeks[i];

        if (dow.time != null && dow.time != "") {
          empty = false;

          var t = moment(dow.time, "HH:mm");

          if (!t.isValid()) {
            return RepeatService.days()[i] + " is not in format HH:mm";
          }
        }
      }

      if (empty) {
        return "You must specify at least one time for your service";
      }
    },
    getRideTypes: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/ride_types/all`;

        let response = await axios.get(url, {
          params: {},
        });

        this.rideTypes = response.data;

        this.getRepeatService();

        console.log("got ride types");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ride types " + error);
      }
    },
    getRepeatService: async function () {
      this.loading = true;

      try {
        var url = `${this.$store.state.apiUrl}/repeat_service/get/${this.$route.params.id}`;

        let response = await axios.get(url, {
          params: {},
        });

        var repeatServiceModel = response.data.repeat_service;

        this.repeatService = new RepeatService(
          this.rideTypes,
          repeatServiceModel,
          this.$store
        );

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get repeat services " + error);
      }
    },
    changePage: function (page) {
      this.pagination.page = page;
      console.log(page);
      this.loadBookings();
      this.loadBookings();
    },
    loadBookings: async function () {
      this.loadingTrips = true;

      try {
        var url = `${this.$store.state.apiUrl}/repeat_service/getWithTrips/${this.$route.params.id}?offset=${
            this.count * (this.pagination.page - 1)
        }&count=${this.count}`;

        let response = await axios.get(url, {
          params: {},
        });

        var repeatServiceModel = response.data.repeat_service;

        if (repeatServiceModel.trip_a != null) {
          this.repeatService.repeatServiceModel.trip_a.repeat_booking_entries = [];
          this.repeatService.repeatServiceModel.trip_a.repeat_booking_entries.push(... repeatServiceModel.trip_a.repeat_booking_entries);
        }

        if (repeatServiceModel.trip_b != null) {
          this.repeatService.repeatServiceModel.trip_b.repeat_booking_entries = [];
          this.repeatService.repeatServiceModel.trip_b.repeat_booking_entries.push(... repeatServiceModel.trip_b.repeat_booking_entries)
        }

        this.loadedTrips = true;

        this.loadingTrips = false;

        this.num_pages = response.data.pages.num_pages;

        console.log(response.data.pages.num_pages);

        this.repeatService.loadingA = false;
        this.repeatService.loadingB = false;
        this.repeatService.loading = false;
      } catch (error) {
        this.loadingTrips = false;
        console.log("Failed to get repeat services " + error);
      }
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },
  },
};
</script>
